import React, { useState, useEffect } from "react";
import { Row, Col, Card } from "react-bootstrap";
import { Icon } from "@iconify/react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import avatar1 from "../../assets/img/default.jpg";
import avatar2 from "../../assets/img/default.jpg";
import { userStatics, recentUsers } from "../../common/api";
import { ShowToast } from "../../common/function";
import { Sentry } from "react-activity";
import ConfigApp from "../../common/config";
import { format } from "date-fns";


export default function Dashboard() {
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState([]);
  const [loading, setLoading] = useState(false);
  const [recentUsersData, setRecentUsersData] = useState([]);
  const [recentUsersLoading, setRecentUsersLoading] = useState(false);
  console.log('zsxdcfgvhbjnk');
  


  const formatDate = (dateString) => {
    return format(new Date(dateString), "dd-MM-yyyy");
  };

  const getStatusStyle = (status) => {  
    switch (status) {
      case "Active":
        return {
          backgroundColor: "rgba(40, 199, 111, 0.12)",
          color: "#28c76f",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };
      case "In Active":
        return {
          backgroundColor: "rgba(146, 0, 0, 0.12)",
          color: "#920000",
          padding: "5px 10px",
          borderRadius: "5px",
          display: "inline-block",
        };
      default:
        return {};
    }
  };

  useEffect(() => {
    const userStaticsData = async () => {
      setLoading(true);

      const token = localStorage.getItem("token");
      if (token) {
        const response = await userStatics(token);
        setLoading(false);
        if (response.success) {
          setCount(response.body);
        } else {
          ShowToast(0, response.message);
        }
      }
    };
    userStaticsData();
    recentUsersList();
  }, []);

  const recentUsersList = async () => {
    setRecentUsersLoading(true);
    const token = localStorage.getItem("token");
    if (token) {
      const response = await recentUsers(token);
      setRecentUsersLoading(false);

      if (response?.success == true) {
        const filteredUsers = response.body.filter(
          (user) =>
            user.full_name &&
            typeof user.full_name === "string" &&
            user.full_name.trim().length > 0
        );
        setRecentUsersData(filteredUsers);
      } else {
        ShowToast(0, response.message);
      }
    }
  };


  const columns = [
    {
      name: "Sr. No.",
      width: "100px",
      selector: (row, index) => index + 1,
      sortable: true,
      cell: (row, index) => index + 1,
    },
    {
      name: "Name",
      minWidth: "220px",
      selector: (row) => row.full_name,
      sortable: true,
      cell: (row) => (
        <>
          <img
            className="table_img rounded-circle img-thumbnail me-2"
            src={row.profile_url
              ? row.profile_url.startsWith('http')
                ? row.profile_url
                : `${ConfigApp.IMAGE_URL}${row.profile_url}`
              : avatar1
            }
            alt=""
          />
          {row.full_name}
        </>
      ),
    },
    {
      name: "Email",
      minWidth: "190px",
      selector: (row) => row.email,
      sortable: true,
      cell: (row) => row.email,
    },
    {
      name: "Type",
      minWidth: "100px",
      selector: (row) => row.login_type,
      sortable: true,
      cell: (row) => row.login_type,
    },
    {
      name: "Created On",
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
      cell: (row) => formatDate(row.createdAt),
    },
    {
      name: "Status",
      selector: (row) => row.is_active=='0' ? "Active" : "In Active",
      sortable: true,
      cell: (row) => (
        <span style={getStatusStyle(row.is_active=='0' ? "Active" : "In Active")}>{row.is_active=='0' ? "Active" : "In Active"}</span>
      ),
    },
    {
      name: "Actions",
      minWidth: "140px",
      cell: (row) => (
        <>
          <Link className="btnview" to={`/users/view-user`} state={{ userId: row._id ,dashboard:true}}>
            <Icon icon="tabler:eye"></Icon>
          </Link>
        </>
      ),
    },
  ];
  const [data] = useState([
    {
      id: 1,
      name: "Maria James",
      imgurl: avatar1,
      email: "maris@gmail.com",
      type: "Google",
      CreatedOn: "15-09-2024",
      status: "Active",
    },
    {
      id: 2,
      name: "Johnson Charles",
      imgurl: avatar2,
      email: "johnson@gmail.com",
      type: "Apple",
      CreatedOn: "20-09-2024",
      status: "In Active",
    },
    {
      id: 3,
      name: "Maria James",
      imgurl: avatar1,
      email: "maris@gmail.com",
      type: "Google",
      CreatedOn: "15-09-2024",
      status: "Active",
    },
    {
      id: 4,
      name: "Johnson Charles",
      imgurl: avatar2,
      email: "johnson@gmail.com",
      type: "Apple",
      CreatedOn: "20-09-2024",
      status: "Active",
    },
    {
      id: 5,
      name: "Maria James",
      imgurl: avatar1,
      email: "maris@gmail.com",
      type: "Google",
      CreatedOn: "15-09-2024",
      status: "Active",
    },
    {
      id: 6,
      name: "Johnson Charles",
      imgurl: avatar2,
      email: "johnson@gmail.com",
      type: "Apple",
      CreatedOn: "20-09-2024",
      status: "In Active",
    },
  ]);
  // Filter data based on search text
  const filteredData =
    recentUsersData && recentUsersData.length > 0
      ? recentUsersData.filter(
          (item) =>
            JSON.stringify(item)
              .toLowerCase()
              .indexOf(searchText.toLowerCase()) !== -1
        )
      : [];
  return (
    <React.Fragment>
      <Row className="g-3">
        <Col lg={3}>
          <div className="stats">
            <span className="statsicon">
              <Icon icon="tabler:users" color="#FF00C7" />
            </span>
            <div className="stats-cont">
              <h4>Total Users</h4>
              <p>
                {loading ? (
                  <Sentry
                    color="#2B5AAC"
                    size={20}
                    speed={1}
                    animating={true}
                  />
                ) : count?.totalUsers ? (
                  count?.totalUsers
                ) : (
                  0
                )}
              </p>
            </div>
          </div>
        </Col>
        <Col lg={3}>
          <div className="stats">
            <span className="statsicon statsblue">
              <Icon icon="material-symbols-light:post-add-rounded" />
            </span>
            <div className="stats-cont">
              <h4>Total Posts</h4>
              <p>
                {loading ? (
                  <Sentry
                    color="#2B5AAC"
                    size={20}
                    speed={1}
                    animating={true}
                  />
                ) : count?.totalPosts ? (
                  count?.totalPosts
                ) : (
                  0
                )}
              </p>
            </div>
          </div>
        </Col>
        <Col lg={3}>
          <div className="stats">
            <span className="statsicon statsblue1">
              <Icon icon="material-symbols-light:ads-click-rounded" />
            </span>
            <div className="stats-cont">
              <h4>Total Ads</h4>
              <p>
                {loading ? (
                  <Sentry
                    color="#2B5AAC"
                    size={20}
                    speed={1}
                    animating={true}
                  />
                ) : count?.totalAds ? (
                  count?.totalAds
                ) : (
                  0
                )}
              </p>
            </div>
          </div>
        </Col>
        <Col lg={3}>
          <div className="stats">
            <span className="statsicon statsgreen">
              <Icon icon="healthicons:money-bag-outline" />
            </span>
            <div className="stats-cont">
              <h4>Revenue</h4>
              <p>
                {loading ? (
                  <Sentry
                    color="#2B5AAC"
                    size={20}
                    speed={1}
                    animating={true}
                  />
                ) : count?.total ? (
                  `$${count?.total}`
                ) : (
                  0
                )}
              </p>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="mt-2">
        <Col lg={12}>
          <Card>
            <Card.Header className="py-4">
              <h5>Recent Users</h5>
            </Card.Header>
            <Card.Body>
              <div className="text-end mb-3">
                <input
                  type="text"
                  placeholder="Search..."
                  className="searchfield"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div>
              {recentUsersLoading ? (
                <Sentry
                  color="#2B5AAC"
                  size={30}
                  speed={1}
                  animating={true}
                  style={{ marginLeft: "45%" }}
                />
              ) : (
                <DataTable
                  columns={columns}
                  data={filteredData}
                  pagination
                  responsive
                  className="custom-table"
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
}
